import { type FC, useState } from "react";
import { v7 } from "uuid";
import { type InspectionSeverity, inspectionSeverityOptions } from "../api/dto/InspectionFinding";
import { Input } from "../components/form/Input";
import { Select } from "../components/form/Select";
import { ModalFooter } from "../components/layout/ModalProvider";
import {faCircleCheck} from "@fortawesome/free-solid-svg-icons";

const filterSeverityOptions = (allowed: InspectionSeverity[]): { [key: string]: string } =>
  Object.fromEntries(
    Object.entries(inspectionSeverityOptions).filter(([key]) =>
      allowed.includes(key as InspectionSeverity),
    ),
  );

export const AddInspectionFindingModal: FC<{
  questionId: string;
  availableSeverities: InspectionSeverity[];
  onStage: (finding: {
    id: string;
    questionId: string;
    severity: InspectionSeverity;
    description: string;
  }) => void;
}> = (props) => {
  const [severity, setSeverity] = useState<InspectionSeverity>(props.availableSeverities[0]);
  const [description, setDescription] = useState<string>("");

  const save = () => {
    if (!description) {
      return;
    }
    props.onStage({ id: v7(), questionId: props.questionId, severity, description });
  };

  return (
    <div className={""}>
      <Select
        label={"Klassificatie"}
        options={filterSeverityOptions(props.availableSeverities)}
        value={severity}
        onChange={(v) => setSeverity(v as InspectionSeverity)}
      />
      <Input
        type={"textarea"}
        label={"Toelichting"}
        value={description}
        onChange={setDescription}
      />
      <ModalFooter text={"Bevestig"} icon={faCircleCheck} onSubmit={save} disabled={description.trim().length === 0} />
    </div>
  );
};
